import { render } from "./StatisticsView.vue?vue&type=template&id=a6cd19bc&scoped=true"
import script from "./StatisticsView.vue?vue&type=script&lang=js"
export * from "./StatisticsView.vue?vue&type=script&lang=js"

import "./StatisticsView.vue?vue&type=style&index=0&id=a6cd19bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6cd19bc"],['__file',"src/views/StatisticsView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a6cd19bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a6cd19bc', __exports__)) {
    api.reload('a6cd19bc', __exports__)
  }
  
  module.hot.accept("./StatisticsView.vue?vue&type=template&id=a6cd19bc&scoped=true", () => {
    api.rerender('a6cd19bc', render)
  })

}


export default __exports__